import React from "react";
import { Link } from "react-router-dom";
import "./Trial.css";

const Trial = () => {
  return (
    <section className="trial-cta">
      <div className="trial-cta-glow trial-glow-1" />
      <div className="trial-cta-glow trial-glow-2" />
      <div className="trial-cta-glow trial-glow-3" />
      <div className="trial-cta-inner">
        <div className="trial-cta-badge">
          <span className="trial-badge-dot" />
          Limited Time Offer
        </div>
        <h2 className="trial-cta-title">
          Ready to Transform<br />
          <span>Your Business?</span>
        </h2>
        <p className="trial-cta-desc">
          Join 5,000+ Indian businesses running smarter with Auditus-iERP.
          Free setup, free data migration, and free training included.
        </p>
        <div className="trial-cta-actions">
          <Link to="/Demo" className="trial-btn-primary">
            <span>Get Free Demo</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          </Link>
          <a href="tel:+919032032612" className="trial-btn-outline">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>
            <span>Call Us Now</span>
          </a>
        </div>
        <div className="trial-trust-row">
          {["Free Setup", "Free Migration", "Free Training", "Cancel Anytime"].map((t) => (
            <span key={t} className="trial-trust-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M20 6L9 17l-5-5" /></svg>
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trial;
